/* 21+ age gate. Blocks entry until confirmed; remembers for 30 days. Bypassed in
   the theme editor (Shopify.designMode). Dispatches 'u7:age-verified' on pass. */
(function () {
  const gate = document.querySelector('[data-u7-age-gate]');
  if (!gate) return;
  const KEY = 'u7_age_verified';
  const verified = () => document.cookie.includes(KEY + '=1');
  const remember = () => { document.cookie = KEY + '=1; path=/; max-age=' + (60 * 60 * 24 * 30); };

  function pass() {
    gate.hidden = true; gate.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('u7-noscroll'); document.body.classList.add('u7-age-ok');
    document.dispatchEvent(new CustomEvent('u7:age-verified'));
  }
  function show() {
    gate.hidden = false; gate.setAttribute('aria-hidden', 'false');
    document.body.classList.add('u7-noscroll');
    const yes = gate.querySelector('[data-u7-age-yes]'); if (yes) yes.focus();
  }

  if (window.Shopify && Shopify.designMode) { document.body.classList.add('u7-age-ok'); return; }
  if (verified()) { document.body.classList.add('u7-age-ok'); return; }

  gate.querySelector('[data-u7-age-yes]').addEventListener('click', () => { remember(); pass(); });
  gate.querySelector('[data-u7-age-no]').addEventListener('click', () => {
    const deny = gate.querySelector('[data-u7-age-deny]'); if (deny) deny.hidden = false;
    const url = gate.dataset.redirect;
    if (url) { setTimeout(function () { window.location.href = url; }, 2500); }
  });
  // Trap focus inside the dialog + block ESC (gate must be answered)
  gate.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { e.preventDefault(); return; }
    if (e.key === 'Tab') {
      const focusable = gate.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  show();
})();
